'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@eliadmin/core/src/components/ui/tabs';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import {
  getRestaurantSpaceAlbum,
  getRestaurantSpaceCover,
  getRestaurantSpaceDescription,
  type RestaurantSpace,
} from './restaurant-spaces-utils';

export const RestaurantSpaceDetailTabs = ({ spaces }: { spaces: RestaurantSpace[] }) => {
  const defaultValue = spaces[0]?.slug;

  if (!defaultValue) return null;

  return (
    <Tabs defaultValue={defaultValue} className="flex w-full flex-col gap-8">
      <TabsList className="hide-scroll-bar mx-auto flex h-fit w-full items-center justify-start overflow-x-auto rounded-none bg-secondary p-1 md:w-fit">
        {spaces.map(space => (
          <TabsTrigger
            key={space.slug}
            value={space.slug}
            className="rounded-none bg-transparent px-6 py-3 text-base text-primary shadow-none"
          >
            {space.name}
          </TabsTrigger>
        ))}
      </TabsList>

      {spaces.map(space => {
        const album = getRestaurantSpaceAlbum(space);
        const cover = getRestaurantSpaceCover(space);

        return (
          <TabsContent key={space.slug} value={space.slug} className="m-0">
            <article className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,0.85fr),minmax(0,1.15fr)] lg:gap-12">
              <div className="flex flex-col gap-4">
                <h2 className="font-heading text-3xl font-normal text-black sm:text-4xl">
                  {space.name}
                </h2>
                <HtmlRenderer
                  html={getRestaurantSpaceDescription(space)}
                  className="text-muted-foreground"
                />
              </div>

              <div className={cn('grid gap-3', album.length > 1 ? 'grid-cols-2' : 'grid-cols-1')}>
                {(album.length ? album : [cover]).slice(0, 8).map((image, index) => (
                  <div
                    key={`${image}-${index}`}
                    className={cn(
                      'relative min-h-[220px] overflow-hidden rounded-md bg-secondary',
                      index === 0 && album.length > 1 && 'col-span-2 min-h-[420px]',
                    )}
                  >
                    <Image
                      src={image}
                      alt={space.name}
                      fill
                      className="object-cover"
                      sizes="(min-width: 1024px) 50vw, 100vw"
                    />
                  </div>
                ))}
              </div>
            </article>
          </TabsContent>
        );
      })}
    </Tabs>
  );
};
